<template>
  <div class="password-change-container">
    <div class="password-change-card">
      <h1>Zmena hesla</h1>
      <div class="form-group">
        <label for="newPassword">Nove heslo:</label>
        <input type="password" id="newPassword" v-model="newPassword" />
      </div>
      <div class="form-group">
        <label for="confirmPassword">Nove heslo (zadaj znova):</label>
        <input type="password" id="confirmPassword" v-model="confirmPassword" />
      </div>
      <button class="change-btn" @click="changePassword" :disabled="isButtonDisabled">Zmenit heslo</button>
    </div>
  </div>
</template>

<script>
//import axios from 'axios';
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'

export default {
  setup() {
    const store = useStore()
    const router = useRouter()

    // Reactive data - convert from data() function
    const newPassword = ref('')
    const confirmPassword = ref('')
    const isButtonDisabled = ref(false)

    // Computed properties - convert from computed object
    const currentUser = computed(() => store.state.auth.username)

    // Methods - convert to regular functions
    const changePassword = async () => {
      if (isButtonDisabled.value) return

      isButtonDisabled.value = true

      if (newPassword.value !== confirmPassword.value) {
        alert('Zadali jste 2 rozdilna hesla! Skuste to znovu.')
        isButtonDisabled.value = false
        return
      }

      // Re-enable the button after 5 seconds
      setTimeout(() => { isButtonDisabled.value = false }, 5000)
      store.dispatch('auth/changePassword', currentUser.value, newPassword.value)
      .then( async () => {
        alert('Heslo bolo zmenene')
        await new Promise(resolve => setTimeout(resolve, 3000))
        router.push({name: 'dashboardMain'})
      }, error=>{
        console.log('Chyba pri zmene hesla.', error)
      })
    }

    // Lifecycle hook - convert created() to onMounted()
    onMounted(() => {
      // Fetch tasks from backend and set to this.tasks
        //store.(); // Fetch tasks when the component is created
    })

    return {
      currentUser,
      newPassword,
      confirmPassword,
      isButtonDisabled,
      changePassword
    }
  }
}
</script>


<style scoped>
.password-change-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 20px;
  background-color: #1e1e1e;
}

.password-change-card {
  background: #333;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 400px;
  border: 1px solid #444;
}

h1 {
  color: #fff;
  margin-bottom: 1.5rem;
  text-align: center;
}

.form-group {
  margin-bottom: 1rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  color: #fff;
}

input {
  width: 100%;
  padding: 0.5rem;
  background-color: #444;
  border: 1px solid #555;
  border-radius: 4px;
  margin-bottom: 1rem;
  color: #fff;
}

input:focus {
  outline: none;
  border-color: #007bff;
}

.change-btn {
  width: 100%;
  padding: 0.75rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  transition: background-color 0.3s;
}

.change-btn:hover {
  background-color: #0056b3;
}

.change-btn:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
  opacity: 0.7;
}
</style>